module.exports = __webpack_public_path__ + "img/bg_chaozhishangcheng_bg.25af6c71.png";